import { gql } from "@outschool/ui-apollo";

export const waitlistedClassesQuery = gql`
  query WaitlistedClassesQuery(
    $parentUid: ID!
    $learnerUid: ID
    $page: Int!
    $limit: Int!
  ) {
    paginatedWaitlistSeatsForParent(
      userUid: $parentUid
      learnerUid: $learnerUid
      page: $page
      limit: $limit
    ) {
      results {
        uid
        createdAt
        learner {
          uid
          name
          avatar
          age
        }
        enrollment {
          uid
        }
        section {
          uid
          canceled_at
          deleted_at
          end_time
          is_self_paced
          price_cents
          availableSpaces
          published_at
          start_time
          waitlistSeatsCount
          meetingDays
          activity {
            uid
            duration_weeks
            size_max
            hasTeacherSchedule
            isClub
            isOneTime
            is_ongoing_weekly
            price_cents
            published_at
            title
            titleTranslated
            slug_id
            weekly_meetings
            isFlexSchedule
            isSelfPaced
            details {
              photo
            }
            leader {
              uid
              name
              photo
              leader_link
              timeZone
            }
          }
          leader {
            uid
            name
            photo
            leader_link
            timeZone
          }
          meetings {
            uid
            start_time
            end_time
          }
          nextOngoingMeeting {
            uid
            start_time
            end_time
          }
        }
      }
      pageInfo {
        totalPages
        totalItems
        currentPage
      }
    }
  }
`;
